import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import { COHORTS_PATH } from '@verantos-dev/core-constants';
import { type CohortAttritionDetail } from '@verantos-dev/types-cohorts';
import { type ListResponse } from '@verantos-dev/types-common';

export const datasetApiSlice = baseGatewayApiV1
  .enhanceEndpoints({
    addTagTypes: ['cohortAttrition'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCohortAttritionByCohortProfileId: builder.query<
        ListResponse<CohortAttritionDetail>,
        { projectId: string; cohortProfileId: string }
      >({
        query: ({ cohortProfileId, projectId }) =>
          `/${COHORTS_PATH}/${projectId}/cohort-profile/${cohortProfileId}/attrition`,
        providesTags: (result, error, params) => [
          { type: 'cohortAttrition', id: params.cohortProfileId },
        ],
      }),
    }),
  });

export const {
  useGetCohortAttritionByCohortProfileIdQuery,
  useLazyGetCohortAttritionByCohortProfileIdQuery,
} = datasetApiSlice;
